<template>
  <compliance-dialog v-model="internalShow" :title="$t('global.pswDialog.psw')">
    <template #default>
      <v-form v-model="isValid" ref="form" autocomplete="off">
        <compliance-password
          v-model.trim="oldPsw"
          :label="$t('global.pswDialog.oldPsw')"
          :rules="oldPswRules"
          counter
          id="oldPswId"
          ref="oldPsw"
          required
        />
        <compliance-password
          v-model.trim="newPsw"
          :label="$t('global.pswDialog.newPsw')"
          counter
          id="newPswId"
          ref="newPsw"
          required
        />
        <compliance-password-confirm
          v-model.trim="confirmPsw"
          :password="newPsw"
          id="confirmPswId"
          ref="confirmPsw"
          required
        />
      </v-form>
    </template>

    <template #actions>
      <v-btn depressed :disabled="!isValid" color="primary" @click="submit">{{
        $t("global.pswDialog.submit")
      }}</v-btn>
    </template>
  </compliance-dialog>
</template>

<script>
import { put } from "@/model/api";
import ComplianceDialog from "@/components/ComplianceDialog";
import CompliancePassword from "@/components/CompliancePassword";
import CompliancePasswordConfirm from "@/components/CompliancePasswordConfirm";

export default {
  name: "ChangePasswordDialog",

  components: {
    ComplianceDialog,
    CompliancePassword,
    CompliancePasswordConfirm,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isValid: false,
      oldPsw: "",
      oldPswRules: [],
      newPsw: "",
      confirmPsw: "",
    };
  },

  computed: {
    internalShow: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        let payload = {
          oldPassword: this.oldPsw,
          newPassword: this.newPsw,
        };
        put("/user/" + this.$store.state.username + "/change-password", payload)
          .then(() => {
            this.$store.commit("clearPasswordExpiryWarning");
            this.$store.commit(
              "showSuccess",
              this.$t("global.pswDialog.pswChangedMsg")
            );
            this.close();
          })
          .catch((ex) => {
            this.$store.commit("showError", ex);
          });
      }
    },

    close() {
      this.internalShow = false;
      this.oldPsw = "";
      this.newPsw = "";
      this.confirmPsw = "";
    },
  },
};
</script>
